import { render, staticRenderFns } from "./DeleteAccountFromFb.vue?vue&type=template&id=a0fd3dda&scoped=true"
import script from "./DeleteAccountFromFb.vue?vue&type=script&lang=js"
export * from "./DeleteAccountFromFb.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccountFromFb.vue?vue&type=style&index=0&id=a0fd3dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fd3dda",
  null
  
)

export default component.exports